import React from "react";
import CustomSelect from "../common/Select";

function SelectorMedioPublicitario({ value, onChange, error, required = false, mediosPublicitarios = [] }) {
  // Convertir medios publicitarios a formato de opciones
  const opcionesMedio = mediosPublicitarios.map(medio => ({
    value: medio.id,
    label: medio.nombre
  }));

  return (
    <CustomSelect
      options={opcionesMedio}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Cómo se enteró"
      error={error}
      required={required}
    />
  );
}

export default SelectorMedioPublicitario;